import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-U6-logo_svg__svg3638",
  viewBox: "0 0 400.86 321.47"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-U6-logo_svg__cls-1{fill:#ba0c2f}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-U6-logo_svg__path3465",
      d: "M107.68 81.84S-6.18 136.21.26 195.15c1.53 13.99 10.59 25.25 25.54 33.94 14.31-20.67 29.33-40.74 44.71-59.86-8.56-35.54 37.17-87.38 37.17-87.38ZM81.41 186.82c-18.37 16.9-34.96 33-48.15 46.16 26.57 12.48 67.4 18.49 116.13 18.49 43.48 0 93.25-4.78 144.83-14 22.26-3.99 44.86-8.8 67.43-14.41 13.11-3.27 26.2-6.78 39.21-10.57 0 0-17.9 1.69-45.38 3.29-20.26 1.18-45.72 2.31-73.05 2.67-5.72.08-11.54.11-17.39.11-73.18 0-154.34-6.29-183.62-31.73Z",
      class: "svg-U6-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-U6-logo_svg__path3477",
      d: "M285.59 0c-32.42 0-80.9 30.81-132.37 79.17 13.09 6.39 25.95 12.95 38.49 19.65 25.53-16.1 49.05-26.63 66.92-26.63.68 0 1.35.02 2.02.05 47.29 2.17 47.53 95.93 47.53 95.93s48.5-103.84 5.19-156.05C306.5 3.84 297.05 0 285.6 0ZM139.81 92.08c-23.11 22.85-46.6 48.96-69.3 77.15a1038.178 1038.178 0 0 0-44.71 59.86 977.053 977.053 0 0 0-23.69 35.84s12.02-12.89 31.14-31.95c13.19-13.16 29.78-29.27 48.16-46.17 27.16-24.98 58.22-51.62 88.02-72.95-10.08-7.61-20.05-14.92-29.62-21.78Z",
      class: "svg-U6-logo_svg__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-U6-logo_svg__path3493",
      d: "M294.22 237.47c3.09 6.27 5.16 12.24 6 17.84 7.04 46.8-84.91 65.22-84.91 65.22s119.95 9.65 158.49-32.87c14.64-16.15 8.54-38.86-12.15-64.6-10.93 2.71-21.88 5.25-32.78 7.59 10.91-2.35 21.85-4.88 32.78-7.59-1.93-2.4-3.98-4.83-6.17-7.28-8.54.5-18.02.99-28.17 1.41 10.15-.43 19.63-.91 28.17-1.41-32.72-36.83-92.94-79.01-163.78-116.95-12.53-6.7-25.38-13.28-38.48-19.67-29.84-14.55-60.92-28.15-92.14-40.14 0 0 35.27 21.91 78.73 53.05 9.57 6.86 19.54 14.16 29.62 21.78 43.29 32.7 88.58 71.14 112.99 104.58h.01c4.79 6.56 8.77 12.93 11.78 19.03ZM185.86 102.58c-4.61 3.01-9.26 6.2-13.96 9.52 4.7-3.32 9.35-6.5 13.96-9.52",
      class: "svg-U6-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "U6-logo"}) } }